import { render, staticRenderFns } from "./groupPolicyMyList.vue?vue&type=template&id=1ded176c&scoped=true"
import script from "./groupPolicyMyList.vue?vue&type=script&lang=js"
export * from "./groupPolicyMyList.vue?vue&type=script&lang=js"
import style0 from "./groupPolicyMyList.vue?vue&type=style&index=0&id=1ded176c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded176c",
  null
  
)

export default component.exports